import {post} from "@/utils/request";

export default class apiYrOrder {
  static async buyAndPay(vipId,payType, form){
    return post('/home/yr_order/buyAndPay', {vipId,payType, ...form})
  }

  static async info(id){
    return post('/home/yr_order/info', {id})
  }
}
